module.exports = __webpack_public_path__ + "static/media/about-top.f14f5286.png";